import React, { useEffect, Suspense } from "react"

import { Routes, Route, BrowserRouter as Router } from "react-router-dom"

import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

// Import Routes all
import { protectedRoutes, publicRoutes, RouteConfig } from "./routes"

// Import all middleware
import Authmiddleware from "~/routes/route"

// layouts Format
import VerticalLayout from "~/components/VerticalLayout/"
import NonAuthLayout from "~/components/NonAuthLayout"
import NotFound from "~/pages/Error/NotFound"
import Preloader from "~/components/Shared/Preloader"

// Import scss
import "./assets/scss/theme.scss"
import ActivityStatusMonitor from '~/components/Shared/ActivityStatusMonitor';
import { initializeTagManager } from '~/hooks/gtm';


// Lazy-load conditionally-shown components so their vendor chunks (lottie, sweetalert, etc.)
// are not pulled into the initial entry bundle.
const HelpSidebar = React.lazy(() => import('~/components/VerticalLayout/HelpSidebar'));
const SenPromotion = React.lazy(() => import('~/components/Common/SenPromotion'));
const TermsOfServiceModal = React.lazy(() => import('~/pages/Terms/TermsOfServiceModal'));

const App = () => {

  useEffect(() => {
    initializeTagManager();
  }, [])

  return (
    <ActivityStatusMonitor>
      <ReactNotifications />
      <Suspense fallback={null}><HelpSidebar /></Suspense>
      <Suspense fallback={null}><SenPromotion /></Suspense>
      <Suspense fallback={null}><TermsOfServiceModal /></Suspense>
      <Router>
        <Suspense fallback={<Preloader />}>
        <Routes>
          {publicRoutes.map((route: RouteConfig) => <Route key={route.path} path={route.path} element={<Authmiddleware
            layout={NonAuthLayout}
            component={route.component}
            componentProps={route.props}
            isProtected={false}
            isSetupRoute={false}
            isGlbaRoute={false}
          />} />)}
          {protectedRoutes.map((route: RouteConfig) => <Route key={route.path} path={route.path} element={<Authmiddleware
            layout={route.layout || VerticalLayout}
            component={route.component}
            componentProps={route.props}
            isProtected={true}
            isSetupRoute={route.isSetupRoute || false}
            isGlbaRoute={route.isGlbaRoute || false}
          />} />)}
          <Route element={<NotFound title="Page not found" />} />
        </Routes>
        </Suspense>
      </Router>
    </ActivityStatusMonitor>
  )
}


export default App
